import { render } from "./UnitNavigation.vue?vue&type=template&id=8d610f34&scoped=true"
import script from "./UnitNavigation.vue?vue&type=script&lang=js"
export * from "./UnitNavigation.vue?vue&type=script&lang=js"

import "./UnitNavigation.vue?vue&type=style&index=0&id=8d610f34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d610f34"]])

export default __exports__